import { SECTION } from 'src/constants/section';
import type { ModuleType } from 'src/types/modulePermission';

export const routePaths = {
  INDEX: '/',
  LOGIN: '/login/',
  NULL: '/null',
  PASSWORD_RESET_CONFIRM: '/reset/:uid/:token/',
  RESET: '/password/reset/',
  START: '/start/',
  REPORT: '/report/',
  TERMS_OF_USAGE: '/terms/',
  TERMS_OF_USAGE_CHATBOT: '/chatbot-terms/',

  // get report pro routes
  MY_REPORTS: '/report/my-reports/',
  WORKSPACE: '/workspace/',

  // planAction routes
  PLAN_ACTION_OVERVIEW: '/plan-action/',
  PLAN_ACTION_STATISTICS: '/plan-action/statistics/',
  PLAN_ACTION_CREATE: '/plan-action/create/',
  PLAN_ACTION_EDIT: '/plan-action/:id',

  // dashboard routes
  DASHBOARD_BASE: '/dashboard/',
  DASHBOARD_DETAIL: '/dashboard/:slug/',

  // user admin routes
  USER_ADMIN_LIST: '/user-admin/',
  USER_ADMIN_DETAIL: '/user-admin/:id/',

  // follow-up routes
  FOLLOW_UP_INSPIRATIONS: '/follow-up-inspirations/',
  TICKET_OVERVIEW: '/ticket-overview/',

  // survey routes
  SURVEY_LIST: '/survey/',
  SURVEY_DETAIL: '/survey/:id/',
  SURVEY_SETTINGS: '/survey/settings/',

  //My Follow-Up routes
  MY_FOLLOW_UP: '/my-follow-up/',

  FOLLOW_UP_ACTIONS: '/follow-up-action/',
};

// My Follow-Up is no actual module
export const modulePaths: {
  [key in ModuleType | SECTION.MY_FOLLOW_UP]?: string;
} = {
  [SECTION.DASHBOARD]: routePaths.DASHBOARD_DETAIL,
  [SECTION.FOLLOW_UP]: routePaths.TICKET_OVERVIEW,
  [SECTION.GET_REPORT]: routePaths.REPORT,
  [SECTION.GET_REPORT_PRO]: routePaths.WORKSPACE,
  [SECTION.MY_FOLLOW_UP]: routePaths.MY_FOLLOW_UP,
  [SECTION.PLAN_ACTION]: routePaths.PLAN_ACTION_OVERVIEW,
  [SECTION.SURVEY]: routePaths.SURVEY_LIST,
  [SECTION.USER_ADMIN]: routePaths.USER_ADMIN_LIST,
  [SECTION.FOLLOW_UP_ACTION]: routePaths.FOLLOW_UP_ACTIONS,
};
